
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/swiper-bundle.css";
import "swiper/components/navigation/navigation.min.css";
import SwiperCore, { Navigation } from "swiper";
import {
  defineComponent,
  ref,
  onMounted,
  onBeforeUnmount,
  watch,
  PropType,
} from "vue";
import { Product } from "domain/entities/shop/product/product";

SwiperCore.use([Navigation]);

export default defineComponent({
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    product: {
      type: Object as PropType<Product>,
      required: true,
    },
    slideTo: {
      type: Function as PropType<(index: number) => number>,
      required: true,
    },
  },
  setup() {
    const spaceBetween = ref(0);
    const slidesPerView = ref(0);

    const updateSpaceBetween = () => {
      if (window.innerWidth <= 1250) {
        if (window.innerWidth <= 530) {
          if (window.innerWidth <= 430) {
            if (window.innerWidth <= 290) {
              slidesPerView.value = 1.9;
              spaceBetween.value = 5;
            } else {
              slidesPerView.value = 2.2;
              spaceBetween.value = 20;
            }
          } else {
            spaceBetween.value = 10;
          }
        } else {
          spaceBetween.value = 20;
          slidesPerView.value = 2.7;
        }
      } else {
        spaceBetween.value = 5;
        slidesPerView.value = 2.8;
      }
    };

    onMounted(() => {
      updateSpaceBetween();
      window.addEventListener("resize", updateSpaceBetween);
    });

    onBeforeUnmount(() => {
      window.removeEventListener("resize", updateSpaceBetween);
    });

    watch(() => window.innerWidth, updateSpaceBetween);

    return {
      spaceBetween,
      slidesPerView,
    };
  },
});
